// Compress an image File client-side before uploading.
// - Resizes longest side to maxWidth (preserving aspect ratio)
// - Re-encodes as JPEG with given quality
// - Smartphone photos (5-20 MB) typically reduce to 300-800 KB
// Returns the original file unchanged for non-images or on failure.
export const compressImage = (file, { maxWidth = 1920, quality = 0.85 } = {}) =>
  new Promise((resolve) => {
    if (!file || !file.type || !file.type.startsWith("image/")) {
      resolve(file);
      return;
    }
    // Skip very small files - already lightweight
    if (file.size < 500 * 1024) {
      resolve(file);
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => resolve(file);
    reader.onload = (e) => {
      const img = new Image();
      img.onerror = () => resolve(file);
      img.onload = () => {
        try {
          const scale = Math.min(1, maxWidth / Math.max(img.width, img.height));
          const canvas = document.createElement("canvas");
          canvas.width = Math.round(img.width * scale);
          canvas.height = Math.round(img.height * scale);
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(
            (blob) => {
              if (!blob) return resolve(file);
              const compressedName = file.name.replace(/\.\w+$/, ".jpg") || "photo.jpg";
              const compressed = new File([blob], compressedName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              resolve(compressed);
            },
            "image/jpeg",
            quality
          );
        } catch (err) {
          resolve(file);
        }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
